{
  "PROFILE_SETTINGS": {
    "LINK": "Setări profil",
    "TITLE": "Setări profil",
    "BTN_TEXT": "Actualizeaza profil",
    "DELETE_AVATAR": "Șterge avatarul",
    "AVATAR_DELETE_SUCCESS": "Avatar a fost șters cu succes",
    "AVATAR_DELETE_FAILED": "Există o eroare în timp ce ștergeți avatarul, vă rugăm să încercați din nou",
    "UPDATE_SUCCESS": "Profilul dvs. a fost actualizat cu succes",
    "PASSWORD_UPDATE_SUCCESS": "Parola ta a fost schimbată cu succes",
    "AFTER_EMAIL_CHANGED": "Profilul tău a fost actualizat cu succes, te rugăm să te autentifici din nou pentru că datele tale de autentificare au fost modificate",
    "FORM": {
      "PICTURE": "Profile Picture",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Imagine pentru semnătura de e-mail",
        "HINT": "Utilizată în semnăturile de e-mail. {'{{'}email_signature_picture{'}}'} este înlocuit cu adresa URL a acestei imagini (nu cu o etichetă de imagine) — folosiți-o ca sursă de imagine (atributul src al unei etichete img) în semnătura dvs. sau în semnătura inbox-ului. Dacă nu este setată, nu se inserează nimic.",
        "DELETE_SUCCESS": "Imaginea pentru semnătura de e-mail a fost ștearsă cu succes",
        "DELETE_FAILED": "A apărut o eroare la ștergerea imaginii pentru semnătura de e-mail, vă rugăm să încercați din nou"
      },
      "AVATAR": "Imagine de profil",
      "ERROR": "Vă rugăm să remediați erorile din formular",
      "REMOVE_IMAGE": "Elimină",
      "UPLOAD_IMAGE": "Încarcă imaginea",
      "UPDATE_IMAGE": "Actualizare imagine",
      "PROFILE_SECTION": {
        "TITLE": "Profil",
        "NOTE": "Adresa ta de email este identitatea ta și este folosită pentru a te autentifica."
      },
      "SEND_MESSAGE": {
        "TITLE": "Taste rapide pentru a trimite mesaje",
        "NOTE": "Puteți selecta o tastă rapidă (enter sau Cmd/Ctrl+Enter) în funcție de preferințele dumneavoastră de a scrie.",
        "UPDATE_SUCCESS": "Setările au fost actualizate cu succes",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Introduceți (↵)",
            "CONTENT": "Trimiteți mesaje apăsând tasta Enter în loc să faceți clic pe butonul trimitere."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Trimiteți mesaje apăsând tasta Cmd/ Ctrl + enter în loc să faceți clic pe butonul trimitere."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Personalizați aspectul tabloului de bord.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Implicit",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Limba dashboardului",
          "NOTE": "Suprascrieți limba contului pentru propriul dashboard. Lăsați gol pentru a folosi limba implicită a contului.",
          "USE_ACCOUNT_DEFAULT": "Folosește limba implicită a contului",
          "API_SUCCESS": "Limba dashboardului dumneavoastră a fost actualizată cu succes",
          "API_ERROR": "A apărut o eroare la actualizarea limbii dashboardului, vă rugăm să încercați din nou"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Limba mesajelor",
          "NOTE": "Alegeți dacă să afișați mesajele originale sau traducerile lor",
          "ORIGINAL": "Original",
          "TRANSLATED": "Tradus"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Comportament la lipire",
          "NOTE": "Alegeți cum să fie procesat conținutul lipit la compunerea mesajelor",
          "UPDATE_SUCCESS": "Setările de lipire au fost actualizate cu succes",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Păstrează toată formatarea",
              "DESCRIPTION": "Păstrează toată formatarea, inclusiv tabele, stiluri și alte elemente HTML la lipirea conținutului."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Text cu linkuri doar",
              "DESCRIPTION": "Convertește în text simplu dar păstrează linkurile clicabile la lipirea conținutului."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Doar text simplu",
              "DESCRIPTION": "Elimină toată formatarea și convertește în text simplu la lipirea conținutului."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Înălțimea casetei de răspuns",
          "NOTE": "Setați înălțimea minimă a casetei de răspuns ca procent din înălțimea ecranului. Se aplică doar conversațiilor prin e-mail.",
          "UPDATE_SUCCESS": "Setarea înălțimii casetei de răspuns a fost actualizată cu succes",
          "PERCENT_LABEL": "Înălțime (% din înălțimea ecranului)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Implicit",
              "DESCRIPTION": "Caseta de răspuns începe mică și crește pe măsură ce scrieți."
            },
            "CUSTOM": {
              "HEADING": "Personalizat",
              "DESCRIPTION": "Caseta de răspuns are întotdeauna cel puțin procentul ales din înălțimea ecranului."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Navigare automată la următoarea conversație",
        "NOTE": "Treceți automat la următoarea conversație deschisă după rezolvarea celei curente",
        "UPDATE_SUCCESS": "Setarea de navigare automată a fost actualizată cu succes"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Formatul de previzualizare a e-mailurilor în lista de conversații",
        "NOTE": "Alegeți ce se afișează în lista de conversații pentru conversațiile din căsuțele de e-mail",
        "SUBJECT": "Subiect",
        "SUBJECT_WITH_NOTE": "Subiect și ultimul mesaj, dacă este o notă internă",
        "UPDATE_SUCCESS": "Setarea de previzualizare a e-mailurilor a fost actualizată cu succes"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Dezactivează scurtăturile de tastatură",
        "NOTE": "Dezactivați toate scurtăturile de tastatură din aplicație",
        "UPDATE_SUCCESS": "Setarea scurtăturilor de tastatură a fost actualizată cu succes"
      },
      "FOLDER_ORDER": {
        "TITLE": "Ordinea dosarelor",
        "NOTE": "Personalizați ordinea în care apar dosarele (vizualizările personalizate) în bara laterală. Trageți și plasați pentru a le rearanja.",
        "NO_FOLDERS": "Nu s-au găsit dosare personalizate. Creați dosare pentru a vă organiza conversațiile."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Configurare bară laterală",
        "NOTE": "Personalizați ce secțiuni apar în bara laterală a conversațiilor.",
        "SAVE_BUTTON": "Salvează configurația",
        "UPDATE_SUCCESS": "Configurația barei laterale a fost actualizată cu succes",
        "UPDATE_ERROR": "A apărut o eroare la actualizarea configurației barei laterale, vă rugăm să încercați din nou",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Toate conversațiile",
          "ALL_CONVERSATIONS_DESC": "Afișează elementul de meniu Toate conversațiile în bara laterală",
          "INBOX": "Inbox",
          "INBOX_DESC": "Afișează inbox-ul principal cu notificări necitite",
          "CONVERSATION_GROUPS": "Mențiuni și neatinse",
          "CONVERSATION_GROUPS_DESC": "Afișează grupurile de conversații Mențiuni și Neatinse",
          "FOLDERS": "Dosare",
          "FOLDERS_DESC": "Afișează vizualizările personalizate (dosare) pentru conversații organizate",
          "TEAMS": "Echipe",
          "TEAMS_DESC": "Afișează conversațiile filtrate după atribuirea la echipe",
          "CHANNELS": "Inbox-uri",
          "CHANNELS_DESC": "Afișează conversațiile filtrate după inbox",
          "LABELS": "Etichete",
          "LABELS_DESC": "Afișează conversațiile filtrate după etichete"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Setări telefon",
        "NOTE": "Introduceți datele de autentificare pentru sistemul dumneavoastră PBX.",
        "USERNAME": "Nume utilizator",
        "PASSWORD": "Parolă",
        "SUBMIT": "Salvează",
        "USERNAME_INVALID": "Numele de utilizator poate conține doar litere, cifre și . _ - + — fără spații și fără adresă de e-mail.",
        "API": {
          "USERNAME_INVALID": "Numele de utilizator nu este un nume de utilizator SIP valid. Utilizați doar litere, cifre și . _ - + — fără spații și fără adresă de e-mail.",
          "USERNAME_TAKEN": "Acest nume de utilizator este deja folosit de un alt agent în acest cont."
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Semnătura mesajului personal",
        "DESCRIPTION": "Creați o semnătură unică a mesajului care să apară la sfârșitul fiecărui email pe care îl trimiteți. Puteți include și o imagine inline.",
        "NOTE": "Create a unique message signature to appear at the end of every message you send from any inbox. You can also include an inline image, which is supported in live-chat, email, and API inboxes.",
        "BTN_TEXT": "Salvarea semnăturii mesajului",
        "API_ERROR": "Nu s-a putut trimite! Încearcă din nou",
        "API_SUCCESS": "Semnătura salvată cu succes",
        "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
        "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save to save the signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "Dimensiunea imaginii trebuie să fie mai mică de {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Semnătura mesajului",
        "ERROR": "Semnătura mesajului nu poate fi goală",
        "PLACEHOLDER": "Introduceți semnătura mesajului personal aici."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Parola",
        "NOTE": "Actualizarea parolei ar reseta autentificările pe mai multe dispozitive.",
        "BTN_TEXT": "Schimba parola"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Token acces",
        "NOTE": "Acest token poate fi utilizat dacă construiți o integrare bazată pe API",
        "COPY": "Copiază",
        "REGENERATE": "Regenerează",
        "REGENERATE_SUCCESS": "Tokenul de acces a fost regenerat cu succes. Vă rugăm să actualizați orice integrare care folosește vechiul token.",
        "REGENERATE_CONFIRM_TITLE": "Regenerați tokenul de acces?",
        "REGENERATE_CONFIRM_MESSAGE": "Acest lucru va invalida tokenul curent. Orice integrare care folosește vechiul token nu va mai funcționa."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Extensie Chrome",
        "NOTE": "Instalați extensia noastră Chrome pentru a obține notificări bogate despre apelurile telefonice primite.",
        "INSTALL_BUTTON": "Instalează extensia",
        "ALREADY_INSTALLED": "Extensie instalată"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "Nimic",
          "MINE": "Assigned",
          "ALL": "Toate",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "Nimic",
          "ASSIGNED": "Conversații atribuite",
          "ALL_CONVERSATIONS": "Toate conversațiile"
        },
        "DEFAULT_TONE": {
          "TITLE": "Tonul de alertă:"
        },
        "CONDITIONS": {
          "TITLE": "Condiții de alertă:",
          "CONDITION_ONE": "Trimiteți alerte audio numai dacă fereastra browserului nu este activă",
          "CONDITION_TWO": "Trimiteți alerte la fiecare 30 de ani până când toate conversațiile atribuite sunt citite"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Citeşte mai mult"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Notificări prin e-mail",
        "NOTE": "Actualizați preferințele de notificare prin e-mail aici",
        "CONVERSATION_ASSIGNMENT": "Trimite notificări prin e-mail atunci când o conversație îmi este atribuită",
        "CONVERSATION_CREATION": "Trimite notificări prin e-mail atunci când o conversație nouă este creată",
        "CONVERSATION_MENTION": "Trimiterea notificărilor prin e-mail atunci când sunteți menționat într-o conversație",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Trimiterea notificărilor prin e-mail atunci când se creează un mesaj nou într-o conversație atribuită",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Trimiterea notificărilor prin e-mail atunci când se creează un mesaj nou într-o conversație atribuită",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "E-mail",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Un mesaj nou este creat într-o conversație fără agent disponibil",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Permite notificările push în timpul unui apel",
        "TEST_PUSH": "Testează",
        "TESTING": "Se testează...",
        "TEST_PUSH_DESCRIPTION": "Trimite notificări de test pentru a verifica configurarea",
        "TEST_NOTIFICATION_ERROR": "Trimiterea notificării de test a eșuat. Vă rugăm să încercați din nou.",
        "TEST_LOCAL_TITLE": "Notificare de test (locală)",
        "TEST_LOCAL_BODY": "Aceasta este o notificare locală a browserului. Dacă o vedeți, notificările browserului funcționează!"
      },
      "API": {
        "UPDATE_SUCCESS": "Preferințele de notificare sunt actualizate cu succes",
        "UPDATE_ERROR": "A apărut o eroare la actualizarea preferințelor, încercați din nou"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Notificări push",
        "NOTE": "Actualizați preferințele de notificare push aici",
        "CONVERSATION_ASSIGNMENT": "Trimite notificări push atunci când o conversație îmi este atribuită",
        "CONVERSATION_CREATION": "Trimite notificări push atunci când o conversație nouă este creată",
        "CONVERSATION_MENTION": "Trimiterea notificărilor push atunci când sunteți menționat într-o conversație",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Trimiterea notificărilor push atunci când se creează un mesaj nou într-o conversație atribuită",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Trimiterea notificărilor push atunci când se creează un mesaj nou într-o conversație participantă",
        "HAS_ENABLED_PUSH": "Ați activat apăsarea pentru acest browser.",
        "REQUEST_PUSH": "Activează notificările push",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Imagine de profil"
      },
      "NAME": {
        "LABEL": "Numele tău complet",
        "ERROR": "Te rugăm să introduci un nume valid",
        "PLACEHOLDER": "Te rugăm să introduci un nume valid"
      },
      "DISPLAY_NAME": {
        "LABEL": "Nume afişat",
        "ERROR": "Te rugăm să introduci un nume valid",
        "PLACEHOLDER": "Te rugăm să introduci numele tău, care va fi folosit în conversații"
      },
      "POSITION": {
        "LABEL": "Poziție",
        "ERROR": "Vă rugăm să introduceți o poziție validă",
        "PLACEHOLDER": "Vă rugăm să introduceți poziția dumneavoastră"
      },
      "CUSTOM_LINE": {
        "LABEL": "Linie personalizată",
        "ERROR": "Vă rugăm să introduceți o linie personalizată validă",
        "PLACEHOLDER": "Vă rugăm să introduceți linia dumneavoastră personalizată"
      },
      "AVAILABILITY": {
        "LABEL": "Disponibilitate",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Ocupat",
          "OFFLINE": "Deconectat"
        },
        "SET_AVAILABILITY_SUCCESS": "Avatar a fost șters cu succes",
        "SET_AVAILABILITY_ERROR": "Nu s-a putut seta disponibilitatea, vă rugăm să încercați din nou"
      },
      "EMAIL": {
        "LABEL": "Adresa ta de email",
        "ERROR": "Vă rugăm să introduceți o adresă de e-mail validă",
        "PLACEHOLDER": "Te rugăm să introduci adresa ta de e-mail, aceasta va fi afișată în conversații"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Parola curentă",
        "ERROR": "Vă rugăm să introduceţi un nume de agent",
        "PLACEHOLDER": "Vă rugăm să introduceți parola curentă"
      },
      "PASSWORD": {
        "LABEL": "Parolă nouă",
        "ERROR": "Te rugăm să introduci o parolă pentru lungimea de 6 caractere sau mai mult",
        "PLACEHOLDER": "Te rog introdu o noua parola"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Confirmare parolă nouă",
        "ERROR": "Confirmarea parolei trebuie să se potrivească cu parola",
        "PLACEHOLDER": "Vă rugăm să reintroduceți noua parolă"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Schimba",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Raportează o eroare",
    "SELECTOR_SUBTITLE": "Selectaţi un cont din următoarea listă",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Raportează o eroare",
    "DESCRIPTION_LABEL": "Descrierea problemei",
    "DESCRIPTION_PLACEHOLDER": "Descrieți problema întâmpinată...",
    "SUBMIT": "Trimite raportul",
    "SUBMITTING": "Se trimite...",
    "CANCEL": "Anulează",
    "SUCCESS": "Raportul erorii a fost trimis cu succes. Mulțumim!",
    "ERROR": "Trimiterea raportului de eroare a eșuat. Vă rugăm să încercați din nou.",
    "VALIDATION_ERROR": "Vă rugăm să descrieți problema înainte de a trimite"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "zile de încercare rămase.",
    "TRAIL_BUTTON": "Cumpara acum",
    "DELETED_USER": "Utilizator șters",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Cont suspendat",
      "MESSAGE": "Contul tău este suspendat. Vă rugăm să contactați echipa de asistență pentru mai multe informații."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Copiază",
      "CODEPEN": "Deschis în CodePen",
      "COPY_SUCCESSFUL": "Cod copiat în clipboard cu succes"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Arată mai multe",
      "SHOW_LESS": "Afișați mai puține"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Descărcare",
      "UPLOADING": "Încărcare...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Această poveste nu mai este disponibilă.",
      "RECORDING_UNAVAILABLE": "Această înregistrare nu mai este disponibilă.",
      "DELETE_RECORDING": {
        "BUTTON": "Șterge înregistrarea apelului",
        "TITLE": "Ștergeți înregistrarea apelului?",
        "DESCRIPTION": "Toate înregistrările acestui apel vor fi șterse definitiv din sistemul telefonic și nu vor putea fi restaurate. Transcrierea și rezumatul apelului rămân.",
        "CONFIRM": "Șterge",
        "SUCCESS": "Înregistrarea apelului a fost ștearsă",
        "ERROR": "Înregistrarea apelului nu a putut fi ștearsă. Încercați din nou."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Vezi pe hartă"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Trimite"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Verificare...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Adaugă Inbox"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "În prezent, vizualizarea:",
    "SWITCH": "Comută contul",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Conversații",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Toate conversațiile",
    "MENTIONED_CONVERSATIONS": "Menţionări",
    "PARTICIPATING_CONVERSATIONS": "Participante",
    "UNATTENDED_CONVERSATIONS": "Neasistat",
    "REPORTS": "Rapoarte",
    "SETTINGS": "Setări",
    "CONTACTS": "Contacte",
    "DATA_ASSISTANT": "Asistent de date",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Acasa",
    "AGENTS": "Agenți",
    "AGENT_BOTS": "Boți",
    "AUDIT_LOGS": "Jurnale de audit",
    "WHATSAPP_TEMPLATES": "Șabloane WhatsApp",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Căsuțe",
    "NOTIFICATIONS": "Notificări",
    "CANNED_RESPONSES": "Răspunsuri predefinite",
    "INTEGRATIONS": "Integrări",
    "PROFILE_SETTINGS": "Setări profil",
    "ACCOUNT_SETTINGS": "Setările contului",
    "APPLICATIONS": "Aplicatii",
    "LABELS": "Etichete",
    "CUSTOM_ATTRIBUTES": "Editează atribut personalizat",
    "AUTOMATION": "Automatizare",
    "MACROS": "Macrocomenzi",
    "TEAMS": "Echipe",
    "BILLING": "Facturare",
    "CUSTOM_VIEWS_FOLDER": "Foldere",
    "CUSTOM_VIEWS_SEGMENTS": "Segmente",
    "ALL_CONTACTS": "Toate persoanele de contact",
    "TAGGED_WITH": "Etichetate cu",
    "NEW_LABEL": "Etichetă nouă",
    "NEW_TEAM": "Echipă nouă",
    "NEW_INBOX": "Inbox nou",
    "REPORTS_CONVERSATION": "Conversații",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Campanii",
    "ONGOING": "În derulare",
    "ONE_OFF": "Unul oprit",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agenți",
    "REPORTS_LABEL": "Etichete",
    "REPORTS_INBOX": "Inbox",
    "REPORTS_TEAM": "Echipa",
    "REPORTS_PHONE": "Telefon",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Prezentare generală",
    "WALLBOARD_QUEUES": "Cozi",
    "WALLBOARD_AGENTS": "Prezentare agenți",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Rapoarte",
    "NO_WAITING_CALLERS": "niciun apelant în așteptare",
    "WAITING_CALLERS": "{count} apelanți în așteptare",
    "SET_AVAILABILITY_TITLE": "Setați-vă ca",
    "SET_YOUR_AVAILABILITY": "Setați-vă disponibilitatea",
    "AVAILABILITY_IMPERSONATING": "Blocat cât timp sunteți conectat ca acest utilizator",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Conversație nouă",
    "DRAFT": "Ciornă",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Prezentare generală",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Asistenta",
      "ARTICLES": "Articles",
      "CATEGORIES": "Categorii",
      "LOCALES": "Limbi",
      "SETTINGS": "Setări",
      "DICTIONARY": "Dicționar"
    },
    "CHANNELS": "Canale",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Marcarea automată a offline-ului",
      "INFO_TEXT": "Permiteți sistemului să vă marcheze automat offline atunci când nu utilizați aplicația sau tabloul de bord.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Citiți Documente"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Domenii și contacte blocate",
    "DESCRIPTION": "Lista domeniilor de email blocate pentru acest cont.",
    "NO_BLOCKED_DOMAINS": "Niciun domeniu blocat găsit.",
    "BLOCKED_CONTACTS_BTN": "Contacte blocate"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Facturare",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Pentru acest plan nu sunt disponibile extraoptiuni",
      "PLAN_NOTE": "În prezent sunteți abonat la planul **{plan}** cu licențe **{quantity}**",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Gestionați-vă abonamentul",
      "DESCRIPTION": "Vizualizați facturile anterioare, editați detaliile de facturare sau anulați abonamentul.",
      "BUTTON_TXT": "Accesați portalul de facturare"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Aveţi nevoie de ajutor?",
      "DESCRIPTION": "Vă confruntați cu probleme în facturare? Suntem aici pentru a vă ajuta.",
      "BUTTON_TXT": "Discută cu noi"
    },
    "NO_BILLING_USER": "Contul de facturare este configurat. Vă rugăm să reîmprospătați pagina și încercați din nou."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Uh oh! Nu am putut găsi niciun cont. Vă rugăm să creați un cont nou pentru a continua.",
    "NEW_ACCOUNT": "Cont Nou",
    "SELECTOR_SUBTITLE": "Creează un cont nou",
    "API": {
      "SUCCESS_MESSAGE": "Agent actualizat cu succes",
      "EXIST_MESSAGE": "Contul există deja",
      "ERROR_MESSAGE": "Nu s-a putut conecta la Woot Server, încercați din nou mai târziu"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Nume companie",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Trimite",
      "CANCEL": "Anulează"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Vizualizați toate comenzile rapide",
    "TITLE": {
      "OPEN_CONVERSATION": "Deschiderea conversației",
      "RESOLVE_AND_NEXT": "Rezolvarea și trecerea la următorul",
      "NAVIGATE_DROPDOWN": "Navigarea elementelor verticale",
      "RESOLVE_CONVERSATION": "Detalii conversație",
      "GO_TO_CONVERSATION_DASHBOARD": "Accesați Tabloul de bord conversație",
      "ADD_ATTACHMENT": "Fişier ataşat",
      "GO_TO_CONTACTS_DASHBOARD": "Accesați Tabloul de bord persoane de contact",
      "TOGGLE_SIDEBAR": "Comutare bară laterală",
      "GO_TO_REPORTS_SIDEBAR": "Accesați bara laterală Rapoarte",
      "MOVE_TO_NEXT_TAB": "Deplasarea la fila următoare din lista de conversații",
      "GO_TO_SETTINGS": "Accesați Pagina Setări",
      "SWITCH_TO_PRIVATE_NOTE": "Comutarea la Notă privată",
      "SWITCH_TO_REPLY": "Comutarea la Răspuns",
      "TOGGLE_SNOOZE_DROPDOWN": "Comutați snooze dropdown",
      "AI_ASSIST_MENU": "Asistență AI",
      "AI_ASSIST_GRAMMAR": "Corectează gramatica",
      "AI_ASSIST_UNIFY_LANG": "Unifică limba mesajului"
    }
  }
}
